import { useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'

import { DEFAULT_STYLE_NAME } from '../consts'

const useTags = () => {
  const modelCode = useSelector(aiImageSelectors.modelCode)
  const sourceModelCode = useSelector(aiImageSelectors.sourceModelCode)
  const styleId = useSelector(aiImageSelectors.styleId)
  const modelsData = useSelector(aiImageSelectors.modelsData)
  const stylesData = useSelector(aiImageSelectors.stylesData)

  const modelCodeToCheck = sourceModelCode || modelCode
  const modelName = modelsData.find(
    model => model.code === modelCodeToCheck
  )?.name
  const styleName = stylesData.find(style => style.id === styleId)?.name

  const styleTag =
    styleName && styleName !== DEFAULT_STYLE_NAME
      ? [{ name: styleName, id: styleId?.toString() || '' }]
      : []

  const modelTag = modelName ? [{ name: modelName, id: modelCodeToCheck }] : []

  return [...styleTag, ...modelTag]
}

export default useTags
